import { render, staticRenderFns } from "./EquipmentCategoriesTable.vue?vue&type=template&id=efd16964"
import script from "./EquipmentCategoriesTable.vue?vue&type=script&lang=js"
export * from "./EquipmentCategoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports